
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mineral-listings-view/[id]",
      function () {
        return require("private-next-pages/mineral-listings-view/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mineral-listings-view/[id]"])
      });
    }
  